module.exports = __webpack_public_path__ + "img/14.2ea7cdd7.jpg";